
import React from 'react'
import { useTranslation } from 'react-i18next'

const statCardIds = ['costReduction', 'timeSaved', 'monitoring'];

const RealResultsFromRealRestaurants = () => {
    const { t } = useTranslation()

    return (
        <div className='bg-primary'>
            <div className='pt-[30px] sm:pt-20 bg-primary w-full px-5' style={{ background: "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)" }}>
                <div className='text-center space-y-4'>
                    <h1 className='text-white text-[32px] md:text-[48px] leading-10 md:leading-[58px] font-bold'>{t('landing.results.title')}</h1>
                    <p className='text-white/80 text-[16px] sm:text-[18px] leading-[28px] font-normal tracking-[0.01em]'>{t('landing.results.subtitle')}</p>
                </div>
                <div className='py-4 sm:py-12 max-w-[1004px] mx-auto grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-5'>
                    {statCardIds.map((id) => (
                        <div key={id} className='border border-white/30 bg-white/10 py-2 md:py-5 px-3 rounded-[20px] space-y-1 sm:space-y-3 text-center'>
                            <h3 className='text-white text-[28px] md:text-[46px] leading-[34px] md:leading-[55px] tracking-[-0.01em] font-extrabold'>{t(`landing.results.${id}.value`)}</h3>
                            <p className='text-white text-[12px] md:text-[16px] leading-[14px] md:leading-[19px] font-semibold'>{t(`landing.results.${id}.label`)}</p>
                        </div>
                    ))}
                </div>
                <div className='w-full mx-auto'>
                    <img src="/assets/dashboard.png" alt="dashboard" width={1130} height={888} className='w-fit mx-auto' />
                </div>
            </div>
        </div>
    )
}

export default RealResultsFromRealRestaurants